'use client';
import * as React from 'react';
import Divider from '@mui/material/Divider';
import { useEventEditingStyledContext } from '../event-editing';
import type { EventDialogSectionProps } from './EventDialog.types';
import DateTimeSection from './DateTimeSection';
import ResourceAndColorSection from './ResourceAndColorSection';
import DescriptionSection from './DescriptionSection';
import { EventDialogTabPanel, EventDialogTabContent } from './EventDialogTabPanel';

interface GeneralTabProps extends EventDialogSectionProps {
  value: string;
}

export function GeneralTab(props: GeneralTabProps) {
  const { occurrence, value } = props;

  const { schedulerId, classes } = useEventEditingStyledContext();

  return (
    <EventDialogTabPanel
      role="tabpanel"
      id={`${schedulerId}-general-tabpanel`}
      aria-labelledby={`${schedulerId}-general-tab`}
      className={classes.eventDialogTabPanel}
      hidden={value !== 'general'}
    >
      <EventDialogTabContent className={classes.eventDialogTabContent}>
        <DateTimeSection occurrence={occurrence} />
        <Divider />
        <ResourceAndColorSection occurrence={occurrence} />
        <Divider />
        <DescriptionSection occurrence={occurrence} />
      </EventDialogTabContent>
    </EventDialogTabPanel>
  );
}
